export default "__VITE_PUBLIC_ASSET__19bfbf11__"